import { NetworkType } from 'abis/set/sets'
import type { AssetMetaData } from 'indices-list'
import { ProductType } from 'sdk'
import {
  arbitrumCurrencies,
  avalancheCurrencies,
  baseCurrencies,
  ethereumCurrencies,
  inputCurrencies,
} from 'utils'

const CAI_DESCRIPTION =
  'The index tracks the performance of the Avalanche ecosystem weighted by market cap. The index is rebalanced monthly and is fully collateralised with the underlying assets.'
const JMX_DESCRIPTION =
  'This index provides complete multi-chain exposure to the top memecoins in crypto. The index is rebalanced every two weeks and the composition is entirely decided by $JOOCE holders'
const ePHTR_DESCRIPTION =
  'ePHTR provides holders with continuously streaming PHTR rewards and exclusive access to other benefits from the Phuture ecosystem.'

export const subgraphLinks: { [key: string]: string } = {
  JMX: `https://gateway.thegraph.com/api/${import.meta.env.VITE_APP_GRAPHQL_API_KEY}/deployments/id/QmU1VnpXR7JdhvPkgFsfZXjiJqdRmLKBGLV4fuPMsTBd2a`,
  ARTXAI: `https://gateway-arbitrum.network.thegraph.com/api/${import.meta.env.VITE_APP_GRAPHQL_API_KEY}/deployments/id/QmPtGvWk56Bw1S9DjUeSq412w7AC4bDdwThf9AYHgjFNKu`,
  CAI: `https://gateway-arbitrum.network.thegraph.com/api/${import.meta.env.VITE_APP_GRAPHQL_API_KEY}/deployments/id/QmdjcbGxpNQVY97JbxtUHZ12Xcy68KpwGA78i5b5AakeaU`,
}

export const ARTXAI: AssetMetaData = {
  symbol: 'artxai',
  longName: 'ARTX AI Smart Fund',
  tagLine: 'AI powered fund exposed to megacaps',
  returnBarColour: '#FFCC00',
  nativeTokenColour: '#C7A7FB',
  nativeTokenHoverColour: '#8F4FF6',
  brandColour: '#985F05',
  additionalBrandColour: '#FFCC00',
  description:
    'This AI powered fund leverages ARTX artificial intelligence models to dynamically allocate different proportions to BTC, ETH, and USDC, adapting to market conditions and outperforming benchmarks.',
  network: NetworkType.Arbitrum,
  productType: ProductType.INDEX_V2,
  acceptedCurrencies: inputCurrencies['artxai'],
  productCurrency: arbitrumCurrencies.ARTXAI,
  defaultSlippagePercentage: 0.05,
  decimals: 18,
  productTheme: 'DARK',
  blockExplorer: 'Arbiscan',
  type: 'index-v2',
  address: '0x8e991e9edc300a538ce72186f5bcbc94f4bb9c80',
  methodologyLink: 'https://docs.phuture.finance/our-products/PDI/methodology',
  startDate: 1653350400,
  isCrossChain: false,
  subgraph: subgraphLinks['ARTXAI'],
}

export const CAI: AssetMetaData = {
  symbol: 'cai',
  longName: 'Colony Avalanche Index',
  returnBarColour: '#E5CAFC',
  brandColour: '#BD7AF7',
  additionalBrandColour: '#3E1FFF',
  nativeTokenColour: '#F6B3B3',
  nativeTokenHoverColour: '#E84142',
  description: CAI_DESCRIPTION,
  tagLine: 'The benchmark index for Avalanche',
  network: NetworkType.Avalanche,
  productType: ProductType.INDEX_V1,
  acceptedCurrencies: inputCurrencies['cai'],
  productCurrency: avalancheCurrencies.CAI,
  defaultSlippagePercentage: 0.05,
  decimals: 18,
  productTheme: 'DARK',
  blockExplorer: 'Snowscan',
  type: 'index-v1',
  address: '0x48f88a3fe843ccb0b5003e70b4192c1d7448bef0',
  methodologyLink: 'https://docs.phuture.finance/our-products/CAI/methodology',
  startDate: 1662076800,
  isCrossChain: undefined,
  subgraph: subgraphLinks['CAI'],
}

export const JMX: AssetMetaData = {
  symbol: 'jmx',
  longName: 'JOOCE Memecoin Index',
  tagLine: 'The ultimate memecoin index',
  returnBarColour: '#2EFF04',
  nativeTokenColour: '#0052FF',
  nativeTokenHoverColour: '#1D9AFF',
  brandColour: '#02A816',
  additionalBrandColour: '#2EFF04',
  description: JMX_DESCRIPTION,
  network: NetworkType.Base,
  productType: ProductType.INDEX_V2,
  acceptedCurrencies: inputCurrencies['jmx'],
  productCurrency: baseCurrencies.JMX,
  defaultSlippagePercentage: 0.05,
  decimals: 18,
  productTheme: 'DARK',
  blockExplorer: 'Basescan',
  type: 'index-v2',
  address: '0x83190636c344cf1220ffcbfc0c1198f7867b3667', //base-chain JMX index
  methodologyLink: 'https://docs.jooce.xyz/jmx-governance/listing-criteria',
  startDate: 1738281600,
  isCrossChain: undefined,
  subgraph: subgraphLinks['JMX'],
}

export const ePHTR: AssetMetaData = {
  symbol: 'ephtr',
  longName: 'Phuture Staking',
  tagLine: 'Enhance your PHTR to earn',
  returnBarColour: '#80A9FF',
  nativeTokenColour: '#C7A7FB',
  nativeTokenHoverColour: '#8F4FF6',
  brandColour: '#0FDFA5',
  additionalBrandColour: '#079C76',
  description: ePHTR_DESCRIPTION,
  network: NetworkType.Mainnet,
  productType: ProductType.STAKING,
  acceptedCurrencies: inputCurrencies['ephtr'],
  productCurrency: ethereumCurrencies.ePHTR,
  defaultSlippagePercentage: 0.05,
  decimals: 18,
  productTheme: 'DARK',
  type: 'staked-PHTR',
  blockExplorer: 'Etherscan',
  address: '0x3b9805E163b3750e7f13a26B06F030f2d3b799F5',
  methodologyLink: 'https://docs.phuture.finance/our-products/PDI/methodology',
  startDate: 0, //incorrect
  isCrossChain: undefined,
  subgraph: '',
}
